export class FileAnswer {

    /**Identificador del registro respuesta*/
    public respuestaId: number;

    constructor(
        /**Identificador del evaluado*/
        public credencialId: number,
        /**Identificador del Item*/
        public itemId: number,
        /**Indica la sesión a la que se encuentra asociada la respuesta*/
        public sesion: number,
        /**Archivo de respuesta*/
        public file:File = null

     ) { }
}
